import { quantityToNumber } from './quantityToNumber'

/** Converte quantity/quantityUn do formulário (vírgula) para number na API. */
export const mapOrderItemQuantitiesForApi = (item: any) => ({
  ...item,
  quantity: quantityToNumber(item?.quantity),
  quantityUn: quantityToNumber(item?.quantityUn),
  groupQuantity: quantityToNumber(item?.groupQuantity ?? item?.quantity)
})

export const mapOrderItemsQuantitiesForApi = (items?: any[]) =>
  (items ?? []).map(mapOrderItemQuantitiesForApi)
